import React, { useEffect, useState } from "react";
import { Typography, Box, List, ListItem, ListItemContent,   ColorPaletteProp, ListDivider, Sheet, Table, iconButtonClasses, Button, IconButton, Card, Input, ButtonGroup, Option, Dropdown, MenuButton, Menu, Modal, ModalDialog, ModalClose, DialogTitle, DialogContent, FormControl, FormLabel, Stack, Select, MenuItem } from "@mui/joy";
import { toast } from 'react-toastify';
import { LoadingView, PageTitle, StatusBadge } from "../../../components";
import { formatDate } from "../../../utils";

import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

import {
    logsRequest,
    logsReset
} from '../../../store/actions'

import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { BlockOutlined, CalendarMonthOutlined, CheckCircle, DoNotDisturbOn, FilterAltOutlined, PersonAddOutlined, RefreshOutlined, RemoveRedEyeOutlined, TaskAltOutlined, WarningRounded } from "@mui/icons-material";
import { STATUS } from "../../../constant";

const MobileViewTable = ({ data, props }) => {
    return (
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            {data.map((listItem, index) => (
                <List
                    key={index}
                    size="sm"
                    sx={{
                        '--ListItem-paddingX': 0,
                    }}
                >
                    <ListItem
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'start',
                        }}
                    >
                        <ListItemContent sx={{ display: 'flex', gap: 2, alignItems: 'start' }}>
                            <div>
                                <Typography level="body-xs" gutterBottom><b>Sent To:</b> {listItem.sent_to}</Typography>
                                <Typography level="body-xs" gutterBottom><b>Message:</b> {listItem.message}</Typography>
                                <Typography level="body-xs" gutterBottom><b>Type: </b>{{1: 'SMS', 2: 'Push Logs'}[listItem.sms_type]}</Typography>
                                <Typography level="body-xs" gutterBottom>{formatDate(listItem.created_at)}</Typography>

                                {/* <Dropdown>
                                    <MenuButton variant="plain" size="sm">More ...</MenuButton>
                                    <Menu placement="bottom-end" sx={{ p: 1 }}>
                                        <Typography level="body-sm" gutterBottom><b>Created at:</b> {formatDate(listItem.created_at)}</Typography>
                                        <Typography level="body-sm" gutterBottom><b>Approved at: </b>{formatDate(listItem.approved_at)}</Typography>
                                    </Menu>
                                </Dropdown> */}
                            </div>
                        </ListItemContent>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'flex-end',
                            rowGap: 1
                        }}>
                            <StatusBadge
                                color={
                                    {
                                        1: 'neutral',
                                        2: 'success',
                                        3: 'danger',
                                    }[listItem.status] as ColorPaletteProp
                                }
                            >
                                {{
                                    1: 'Pending',
                                    2: 'Sent',
                                    3: "Fail",
                                }[listItem.status]}
                            </StatusBadge>
                        </Box>

                    </ListItem>
                    <ListDivider />
                </List>
            ))}
        </Box>
    )
}

const DesktopViewTable = ({ data, props }) => {
    return (
        <React.Fragment>
            <Sheet
                className="OrderTableContainer"
                variant="soft"
                sx={{
                    display: { xs: 'none', md: 'flex', lg: 'flex' },
                    // width: '100%',
                    borderRadius: 'sm',
                    flexShrink: 1,
                    overflow: 'auto',
                    minHeight: 0,
                }}
            >
                <Table
                    aria-labelledby="tableTitle"
                    stickyHeader
                    hoverRow
                    stripe='even'
                    sx={{
                        '--TableCell-headBackground': 'var(--joy-palette-background-secondaryColor)',
                        '--Table-headerUnderlineThickness': '1px',
                        '--TableRow-hoverBackground': 'var(--joy-palette-background-level1)',
                        '--TableCell-paddingY': '4px',
                        '--TableCell-paddingX': '8px',
                        // '& tr > *:last-child': {
                        //     position: 'sticky',
                        //     right: 0,
                        //     // bgcolor: 'var(--TableCell-headBackground)',
                        // },
                    }}
                >
                    <thead>
                        <tr style={{ textAlign: 'center' }}>

                            <th style={{ width: 100, padding: '10px 6px', }}>Sent to</th>
                            <th style={{ width: 350, padding: '10px 6px' }}>Message</th>
                            <th style={{ width: 100, padding: '10px 6px' }}>Type</th>
                            <th style={{ width: 100, padding: '10px 6px' }}>Created at</th>
                            <th style={{ width: 100, padding: '10px 6px' }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, index) => (
                            <tr key={index}>
                                <td>
                                    <Typography level="body-sm">{row.sent_to}</Typography>
                                </td>
                                <td>
                                    <Typography level="body-sm">{row.message}</Typography>
                                </td>
                                <td>
                                    <Typography level="body-sm">{{1: 'SMS', 2: 'Push Logs'}[row.sms_type]}</Typography>
                                </td>
                                <td>
                                    <Typography level="body-sm">{formatDate(row.created_at)}</Typography>
                                </td>
                                <td>
                                    <StatusBadge
                                        color={
                                            {
                                                1: 'neutral',
                                                2: 'success',
                                                3: 'danger',
                                            }[row.status] as ColorPaletteProp
                                        }
                                    >
                                        {{
                                            1: 'Pending',
                                            2: 'Sent',
                                            3: "Fail",
                                        }[row.status]}
                                    </StatusBadge>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Sheet>
        </React.Fragment>
    );
}

const LogsPage = ({
    loginResult,

    logsStatus,
    logsResult,
    logsErrorMessage
}) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const isDesktop = useMediaQuery("(min-width:600px)");

    const [logsData, setLogsData] = useState([])

    useEffect(() => {
        if (logsStatus === STATUS.SUCCESS){
            setLogsData(logsResult);
        } 
        else if (logsStatus === STATUS.ERROR){
            toast.error(logsErrorMessage);
            setLogsData([]);
            dispatch(logsReset());
        }
    },[logsStatus])

    useEffect(() => {
        dispatch(logsRequest(loginResult.token))
    },[])

    /* -------- FUNCTION TO SEARCH ------ */
    const [search, setSearch] = useState('');
    const [filterBy, setFilterBy] = useState('name')
    const [isSearchVisible, setIsSearchVisible] = useState(false);

    // filtre by  name
    const filteredData = logsData.filter((item) => {
        if (filterBy === 'sent_to') {
            return item.sent_to.toLowerCase().includes(search.toLowerCase())
        }
        else if (filterBy === 'date') {
            return item.created_at.includes(search)
        }
        else {
            return item.sent_to.toLowerCase().includes(search.toLowerCase())
        }
    })


    /* ------ pagination functions ------- */
    const [currentPage, setCurrentPage] = useState(0);
    const ITEMS_PER_PAGE = 20;
    const pageLength = Math.ceil(filteredData.length / ITEMS_PER_PAGE)

    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(0, prevPage - 1));
    };

    const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, pageLength - 1));
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };



    const paginatedData = filteredData.slice(currentPage * ITEMS_PER_PAGE, (currentPage + 1) * ITEMS_PER_PAGE);
    /* ---- end of pagination functions ------- */




    const checkLoading = () => {
        if (logsStatus === STATUS.LOADING) {
            return true
        } else {
            return false
        }
    }


    return (
        <Box>
            <PageTitle title={'Logs'} />

            <LoadingView loading={checkLoading()} />



            {/* search */}
            {loginResult.partner_type === 1 && logsData.length > 0 &&
                <Sheet
                    className="SearchAndFilters"
                    sx={{
                        display: 'flex',
                        my: 1,
                        gap: 1,
                        flexDirection: { xs: 'column', sm: 'row' },
                        // width: { xs: 'auto', md: '30%' },
                        justifyContent: 'space-between',
                    }}>
                    <Typography level="title-md">Logs List</Typography>

                    <Input
                        size="sm"
                        placeholder={`Search by ${filterBy}`}
                        type={{ date: 'date', sent_to: "text", email: 'email', mobile: 'number' }[filterBy]}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        startDecorator={filterBy === 'date' ? <CalendarMonthOutlined /> : <SearchIcon />}
                        endDecorator={
                            <Dropdown>
                                <MenuButton variant="plain">
                                    {/* <Typography level="body-sm">Filter</Typography> */}
                                    <FilterAltOutlined />
                                </MenuButton>
                                <Menu sx={{ minWidth: '120px', fontSize: '14px' }}>
                                    <MenuItem onClick={() => setFilterBy('name')} selected={filterBy == 'sent_to'}>Sent to</MenuItem>
                                    <MenuItem onClick={() => setFilterBy('date')} selected={filterBy == 'date'}>Created at</MenuItem>
                                </Menu>
                            </Dropdown>
                        }
                        sx={{ width: { xs: 'auto', md: '30%' }, textTransform: 'capitalize' }}
                    />
                </Sheet>}

            {loginResult.partner_type === 1 && (logsData.length > 0 ?
                <>
                    {/* ------ render different view depend on plafform -------- */}
                    <MobileViewTable data={paginatedData} props={{  role: loginResult.role }} />
                    <DesktopViewTable data={paginatedData} props={{  role: loginResult.role }} />

                    {/* Pagination */}
                    {logsData.length > ITEMS_PER_PAGE
                        &&
                        <Box
                            className="Pagination-laptopUp"
                            sx={{
                                pt: 2,
                                gap: 1,
                                [`& .${iconButtonClasses.root}`]: { borderRadius: '50%' },
                                display: 'flex'
                            }}
                        >
                            <Button
                                size="sm"
                                variant="outlined"
                                color="neutral"
                                startDecorator={<KeyboardArrowLeftIcon />}
                                onClick={handlePreviousPage}
                                disabled={currentPage === 0}
                            >
                                {isDesktop ? 'Previous' : ""}
                            </Button>


                            <Box sx={{ flex: 1 }} />
                            {/* for desktop to display page number */}
                            {Array.from({ length: pageLength }).map((_, page) => (
                                <IconButton
                                    key={page}
                                    size="sm"
                                    variant={'outlined'}
                                    color="neutral"
                                    onClick={() => handlePageChange(page)}
                                    disabled={currentPage === page}
                                    sx={{ display: { xs: 'none', md: 'flex' } }}
                                >
                                    {page + 1}
                                </IconButton>
                            ))}

                            {/* for mobile to display page number */}
                            <Typography level="body-sm" mx="auto" textAlign={'center'} sx={{ display: { xs: 'flex', md: 'none' } }}>
                                Page {currentPage + 1} of {pageLength}
                            </Typography>
                            <Box sx={{ flex: 1 }} />



                            <Button
                                size="sm"
                                variant="outlined"
                                color="neutral"
                                endDecorator={<KeyboardArrowRightIcon />}
                                onClick={handleNextPage}
                                disabled={currentPage === pageLength - 1}
                            >
                                {isDesktop ? 'Next' : ""}
                            </Button>
                        </Box>}

                </> :
                <Card sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    top: '20%'
                }}>
                    <WarningRounded sx={{ fontSize: '50px', color: 'background.appcolor' }} />
                    <Typography level="title-md">Resource not Found</Typography>
                    <Typography level="body-sm" textAlign={'center'}>This can be either no logs list available or network issue.</Typography>
                    <Button onClick={() => dispatch(logsRequest(loginResult.token))} startDecorator={<RefreshOutlined />} >REFRESH</Button>
                </Card>
            )}
        </Box>
    )
}

const mapStateToProps = ({ api, auth }) => {
    const {
        otpResult: loginResult,

        logstatus: logsStatus,
        logsResult: logsResult,
        logsErrorMessage: logsErrorMessage
    } = auth


    return {
        loginResult,

        logsStatus,
        logsResult,
        logsErrorMessage
    }
}

export default connect(mapStateToProps, {})(LogsPage)